// create a function to use sessionStorage, with multiple methods

export const SessionStorageHelper = {
  get: (key: string) => {
    return typeof window !== 'undefined' ? sessionStorage.getItem(key) : null
  },
  // Accept any JSON-serializable data
  set: (key: string, value: unknown) => {
    if (typeof window === 'undefined') return
    try {
      sessionStorage.setItem(key, JSON.stringify(value))
    } catch {
      // swallow quota or serialization errors
    }
  },
  remove: (key: string) => {
    if (typeof window === 'undefined') return
    sessionStorage.removeItem(key)
  },
}
